// ts-check
/** @jsx jsx */
import { jsx } from 'theme-ui';
import ProductRequestSampleWithSnipcartButtonForList from '../ProductsList/ProductRequestSampleWithSnipcartButtonForList';
import useSiteConfig from '../useSiteConfig';

// TODO move this into a separate theme.
export default function ProductCardSampleRequestAction({ product }) {
  const content = useContent(product);
  if (!content.hasContent) return null;
  return <ProductRequestSampleWithSnipcartButtonForList product={product} />;
}

export function useContent(product) {
  // TODO also check if logged in?
  const { sampleRequestsWithSnipcartEnabled } = useSiteConfig();
  return {
    hasContent: sampleRequestsWithSnipcartEnabled,
  };
}

ProductCardSampleRequestAction.useContent = useContent;
